import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';




export function* GetWOStatusList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_STATUS_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWOPriorityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_PRIORITY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetWOMaintenanceTypeList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_MAINTENANCE_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetWOAssignmentTypeList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ASSIGNMENT_TYPE_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWOCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* MoveStatus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.MOVE_STATUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}






export function* ExportToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.EXPORT_TO_PDF, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* ExportToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.EXPORT_TO_XLS, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteWorkOrder(action: any): any {
    try {
        const data  = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.WORK_ORDER.DELETE_WORK_ORDER + "?WorkOrderID=" + data.workOrderID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetWorkOrderImages(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_IMAGES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteWorkOrderFiles(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.WORK_ORDER.DELETE_WORK_ORDER_FILES + "?WorkOrderFileID=" + data.workOrderID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* UploadImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.UPLOAD_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* UploadAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.UPLOAD_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* SaveWorkOrder(action: any): any {
    try {
        const data = action.payload;
        console.log("saga call",data);
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}











export function* SaveWorkOrderTaskDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_TASK_DETAILS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetWorkOrderNotesList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_NOTE_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWorkOrderNotes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_NOTE_SAVE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteWorkOrderNotes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.WORK_ORDER.DELETE_WORK_ORDER_NOTE + `?WorkOrderNotesID=${data.WorkOrderNotesID}`, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWOTasks(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_TASK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderCompletionByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderCompletionAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_ATTACHMENTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWorkOrderCompletion(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_COMPLETION, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* UploadWorkOrderCompletionAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_COMPLETION_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* UpdateWorkOrderInprogress(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.UPDATE_WORK_ORDER_INPROGRESS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* UpdateWorkOrderSchedule(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.UPDATE_WORK_ORDER_SCHEDULE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWorkOrderAssets(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_ASSETS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWorkOrderInventory(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_INVENTORY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SaveWorkOrderTasks(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.SAVE_WORK_ORDER_ACTIVITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* InsertStockPicking(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.WORK_ORDER_STOCK_PICKING, data, true);
         if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderTaskLog(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_TASK_LOG, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWOTaskLogExportToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.WO_TASK_LOG_EXPORT_TO_PDF, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWOTaskLogExportToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.WO_TASK_LOG_EXPORT_TO_XLS, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderCompletionLog(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_LOG, data, true);
         if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkOrderKanbanView(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.GET_WORK_ORDER_KANBAN_VIEW, data, true);
         if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* RescheduleWorkOrder(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.RESCHEDULE_WORK_ORDER, data, true);
         if (resp.status >= 200 && resp.status < 300 && resp.data ) {    
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWOTaskAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_ORDER.WORK_ORDER_SAVE_TASK_ATTACHMENTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetPartsByWOID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_ORDER.WORK_ORDER_GET_PARTS_BY_WO_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

















 

 



